<div id="mainLoader" class="mainLoader" [ngStyle]="{ display: showLoader ? 'block' : 'none' }">
  <div class="loader-parent">
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line k12" *ngIf="productTitle === 'K12 Insight'"></div>
  </div>
</div>
<div class="dvPrn" [ngStyle]="{ display: showPrintdiv ? 'block' : 'none' }">
  <span id="prn" class="spnPrintDown">
    <img class="imgPrint" alt="" style="vertical-align: middle" />
    <a href="#" class="font printOption" onclick="print(); return false;">Print</a>
    &nbsp;&nbsp;
    <img alt="" class="imgDownload" style="vertical-align: middle" />
    <a id="aDownLoadPMR" class="font downloadPMR" (click)="downloadSurvey()">Download as PDF</a>
  </span>
</div>
<div class="Plat_Alert Warning Plat_Alert_custom"
  [ngClass]="{ 'showToster': isToasterVisible, 'hideToaster': !isToasterVisible && hasBeenVisible }">
  <span class="success "></span>
  <span class="spnMsg"><span [innerHTML]=" downloadMessage | headerFooterHtml" id="spnPreviewMsgToast"></span></span>
  <span class="closebtn" id="close-btn" (click)="closeToaster()"></span>
</div>
<div id="printBody" [innerHTML]="printBody | headerFooterHtml"></div>